import React from "react"
import PropTypes from "prop-types"

import Footer from './footer.js';
import Header from './header.js';

const Layout = ({ location, title, cssClass, children }) => {
  const pageClass = cssClass ? cssClass : '';
  return (
    <div className="frame">
      <Header />
      <main className={`animated fadeInUp ${pageClass}`}>{children}</main>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  location: PropTypes.object,
  title: PropTypes.string,
  cssClass: PropTypes.string,
  children: PropTypes.array,
}

export default Layout
